import { constants } from '../_constants/conversation.constants';

export const initialState = {
  isLoading: false,
  current: {
    conversation: null,
    messages: []
  },
  conversations: {
    collection: [],
    total: 0
  }
}

export function conversation(state = initialState, action) {
  if (action.type === constants.CVS_INIT) {
    return {
      isLoading: false,
      current: {
        conversation: null,
        messages: []
      },
      conversations: {
        collection: [],
        total: 0
      }
    }
  }

  if (action.type === constants.CVS_INIT_STATE) {
    return {
      isLoading: false,
      current: {
        conversation: null,
        messages: []
      },
      conversations: {
        collection: [],
        total: 0
      }
    }
  }

  if (action.type === constants.CVS_UPDATE_BY_ID) {
    return {
      ...state,
      conversations: {
        ...state.conversations,
        collection: state.conversations.collection.map(conversation => {
          if (conversation.id === action.conversation.id) {
            return action.conversation
          }

          return conversation
        })
      }
    }
  }

  if (action.type === constants.CVS_CONVERSATION_ADD) {
    return {
      ...state,
      conversations: {
        collection: [
          { ...action.conversation },
          ...state.conversations.collection
        ],
        total: state.conversations.total + 1
      }
    }
  }

  if (action.type === constants.CVS_ALL_RETRIEVE_SUCCESS) {
    return {
      ...state,
      isLoading: false,
      conversations: {
        collection: action.conversations.collection.data,
        total: action.conversations.total
      }
    }
  }

  if (action.type === constants.CVS_ALL_RETRIEVE_FAILURE) {
    return {
      ...state,
      isLoading: false
    }
  }

  if (action.type === constants.CVS_ALL_RETRIEVE_REQUEST) {
    return {
      ...state,
      isLoading: true
    }
  }

  if (action.type === constants.CVS_RETRIEVE_SUCCESS) {
    return {
      ...state,
      current: {
        ...state.current,
        conversation: action.data,
      }
    }
  }

  if (action.type === constants.CVS_MSG_ADD) {
    return {
      ...state,
      current: {
        ...state.current,
        messages: [
          action.message,
          ...state.current.messages
        ]
      }
    }
  }

  if (action.type === constants.CVS_MSG_RETRIEVE_FAILURE) {
    return {
      ...state,
      isLoading: false
    }
  }

  if (action.type === constants.CVS_MSG_RETRIEVE_SUCCESS) {
    return {
      ...state,
      isLoading: false,
      current: {
        ...state.current,
        messages: action.messages
      }
    }
  }

  if (action.type === constants.CVS_MSG_RETRIEVE_REQUEST) {
    return {
      ...state,
      isLoading: true
    }
  }

  if (action.type === constants.CVS_PREPEND_MESSAGE) {
    return {
      ...state,
      current: {
        ...state.current,
        messages: [
          { ...action.message },
          ...state.current.messages
        ]
      }
    }
  }

  return state;
}